import Highlighter from "react-highlight-words";
import PropTypes from "prop-types";
import React from "react";

const ResultsHighlighter = ({ className, fieldName, searchQuery, searchField, textToHighlight }) => {
  const searchWords = searchField === fieldName ? [searchQuery] : [];

  return <Highlighter highlightClassName={className} searchWords={searchWords} textToHighlight={textToHighlight || "-"} autoEscape />;
};

ResultsHighlighter.propTypes = {
  className: PropTypes.string,
  fieldName: PropTypes.string,
  searchField: PropTypes.string,
  searchQuery: PropTypes.string,
  textToHighlight: PropTypes.string
};

ResultsHighlighter.defaultProps = {
  className: "",
  fieldName: "",
  searchField: "",
  searchQuery: "",
  textToHighlight: ""
};

export default ResultsHighlighter;



// WEBPACK FOOTER //
// ./src/components/AdvancedSearch/SearchResults/Tiles/ResultsHighlighter.js